import Vue from 'vue'
import axiosInstance from "../../axios";

export const reports = {
  namespaced: true,
  state: {
    sessions: null,
    toolLogs: null,
    searchType: 'sessions'
  },
  mutations: {
    SET_SEARCH_TYPE(state, payload) {
      state.searchType = payload;
    },
    SET_SESSIONS(state, sessions) {
      state.sessions = sessions;
    },
    SET_TOOL_LOGS(state, logs) {
      state.toolLogs = logs;
    }
  },
  actions: {
    FETCH_SESSION_LOGS({commit, rootGetters}, payload) {

      let params = {
        org: rootGetters['auth/GET_FIREBASE_USER'].email.split('@')[1],
        application: 'tat'
      };

      /**
       * If only one date is sent and singleDate is checked, just use a single date
       */
      if (payload.dateRange.length === 1 && payload.singleDate) {
        params.date = payload.dateRange[0]
      } else {
        params.date1 = payload.dateRange[0] || null;
        params.date2 = payload.dateRange[1] || null;
      }

      console.log("PARAMS");
      console.dir(params)

      axiosInstance.get(`${process.env.VUE_APP_LOG_URL}/sessions`, {
        params: params
      }).then((sessions) => {
        console.log("SET");
        console.dir(sessions)
        commit('SET_SESSIONS', sessions.data)
      })
    },
    FETCH_TOOL_LOGS({commit, rootGetters}, payload) {
      axiosInstance.get(`${process.env.VUE_APP_LOG_URL}/tools`, {
        params: {
          org: rootGetters['auth/GET_FIREBASE_USER'].email.split('@')[1],
          application: 'tat'
        }
      }).then((logs) => {
        console.log("SET");
        console.dir(logs)
        commit('SET_TOOL_LOGS', logs.data)
      })
    }
  },
  getters: {
    SESSIONS(state) {
      return state.sessions;
    },
    TOOLS(state) {
      return state.toolLogs;
    },
    SEARCH_TYPE(state) {
      return state.searchType;
    }
  }
};
